import { Chart as ChartJS, registerables } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import { getNiceStepSize } from './influencer-metrics-chart';
import { getTransactionStats } from 'features/influencer/actions';
import CardDashboard from './dashboard-item';

ChartJS.register(...registerables);

const labels = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

const TransactionStatsCard = () => {
  const { transaction, isLoadingTransaction } = useSelector((state) => state.influencerStats);

  const chartData = fillMonthsData(transaction);
  const total = calculateTotal(transaction) || 0;

  const data = {
    labels,
    datasets: [
      {
        data: chartData.map((item) => item.value),
        borderRadius: 100,
        barThickness: 10,
        backgroundColor: 'rgba(0, 158, 247, 1)',
        borderSkipped: false,
      },
    ],
  };

  const maxY = Math.max(...data.datasets[0].data);
  const stepSize = getNiceStepSize(maxY, 4);
  const suggestedMax = Math.ceil(maxY / stepSize) * stepSize;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        displayColors: false,
        // callbacks: {
        //   label: function ({ dataset, dataIndex }) {
        //     return (dataset.data[dataIndex] / 1000000).toFixed(1) + ' Juta';
        //   },
        // },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 8,
            weight: 600,
          },
        },
        border: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
        max: maxY,
        min: 0,
        suggestedMax,
        ticks: {
          // stepSize:
          stepSize,
          font: {
            size: 8,
            weight: 600,
          },
          // callback: function (value) {
          //   if (value === 0) {
          //     return value;
          //   } else {
          //     return this.getLabelForValue(value / 1000000) + ' Juta';
          //   }
          // },
          callback: (value) => value.toLocaleString('id-ID'),
        },
        border: {
          display: false,
        },
      },
    },
  };

  // FUNCTION TO ADD BACKGROUND BEHIND THE CHART BAR
  const barPattern = {
    id: 'barPattern',
    beforeDatasetsDraw(chart) {
      const {
        ctx,
        chartArea: { top, height, bottom },
        scales: { x },
      } = chart;

      const width = chart.getDatasetMeta(0).data[0]?.width;
      const radius = data.datasets[0].borderRadius;

      chart.getDatasetMeta(0).data.forEach((__, index) => {
        ctx.beginPath();
        ctx.fillStyle = '#F2F7FF';

        ctx.roundRect(x.getPixelForValue(index) - width / 2, top, width, height, radius);
        ctx.fill();

        ctx.fillRect(x.getPixelForValue(index) - width / 2, bottom, width, -50);
      });
    },
  };

  return (
    <CardDashboard
      title="Statistik Transaksi"
      value={total}
      separator
      asChild
      filter
      filterAction={getTransactionStats}
      filterAlign="end"
      isLoading={isLoadingTransaction}
    >
      <Bar options={options} data={data} plugins={[barPattern]} />
    </CardDashboard>
  );
};

export default TransactionStatsCard;

function fillMonthsData(data) {
  return Array.from({ length: 12 }, (_, i) => {
    const month = String(i + 1).padStart(2, '0'); // "01".."12"
    const found = data.find((item) => item.label === month);
    return {
      label: month,
      value: found ? found.value : 0,
    };
  });
}

function calculateTotal(monthlyData) {
  return monthlyData.reduce((sum, item) => sum + item.value, 0);
}
